<template>
  <div></div>
</template>

<script>
  import { loginPhoneSystem } from '@/config/api';

  export default {
    name: 'Mobile',
    data() {
      return {};
    },
    created() {
      loginPhoneSystem().then((res) => {
        if (res.data.resCode == 200) {
          window.open(res.data.data);
        }
      });
    },
  };
</script>

<style scoped></style>
